import Skeleton from '@mui/material/Skeleton'
import { useTranslation } from 'react-i18next'
import {
  TableContainer,
  Paper,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
} from '@mui/material'
import { styles } from './subscriptions.styles'

export const SkeletonRow = () => (
  <TableRow>
    <TableCell>
      <Skeleton variant="text" width="80%" height={20} />
    </TableCell>
    <TableCell>
      <Skeleton variant="text" width="80%" height={20} />
    </TableCell>
    <TableCell>
      <Skeleton variant="text" width="80%" height={20} />
    </TableCell>
    <TableCell>
      <Skeleton variant="text" width="80%" height={20} />
    </TableCell>
    <TableCell>
      <Skeleton variant="text" width="80%" height={20} />
    </TableCell>
    <TableCell>
      <Skeleton
        variant="rectangular"
        width={60}
        height={24}
        sx={{ borderRadius: '3px' }}
      />
    </TableCell>
    <TableCell>
      <div
        style={{
          ...styles.actionButtonContainer,
          justifyContent: 'space-between',
          alignItems: 'center',
          gap: '40%',
        }}
      >
        <Skeleton
          variant="rectangular"
          width={80}
          height={32}
          sx={{ borderRadius: '16px' }}
        />
        <Skeleton
          variant="rectangular"
          width={24}
          height={24}
          sx={{ borderRadius: '3px' }}
        />
      </div>
    </TableCell>
  </TableRow>
)

export const SkeletonCard = () => {
  const { t } = useTranslation()

  return (
    <div style={styles.subscriptionCard}>
      <TableContainer
        component={Paper}
        elevation={0}
        sx={{ border: 'none', boxShadow: 'none' }}
      >
        <Table
          sx={{ minWidth: 650, tableLayout: 'fixed', width: '100%' }}
          size="small"
        >
          <TableHead>
            <TableRow sx={{ backgroundColor: '#edf0f4' }}>
              <TableCell
                sx={{
                  fontWeight: 'bold',
                  width: '120px',
                }}
              >
                {t('MySubscriptionsTableHeaderOrderNo')}
              </TableCell>
              <TableCell
                sx={{
                  fontWeight: 'bold',
                  width: '140px',
                }}
              >
                {t('MySubscriptionsTableHeaderDealershipId')}
              </TableCell>
              <TableCell
                sx={{
                  fontWeight: 'bold',
                  width: '100px',
                }}
              >
                {t('MySubscriptionsTableHeaderStartDate')}
              </TableCell>
              <TableCell
                sx={{
                  fontWeight: 'bold',
                  width: '100px',
                }}
              >
                {t('MySubscriptionsTableHeaderEndDate')}
              </TableCell>
              <TableCell
                sx={{
                  fontWeight: 'bold',
                  width: '130px',
                }}
              >
                {t('MySubscriptionsTableHeaderCancellationDeadline')}
              </TableCell>
              <TableCell
                sx={{
                  fontWeight: 'bold',
                  width: '100px',
                }}
              >
                {t('MySubscriptionsTableHeaderStatus')}
              </TableCell>
              <TableCell
                sx={{
                  fontWeight: 'bold',
                  width: '200px',
                }}
              >
                {t('MySubscriptionsTableHeaderActions')}
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            <SkeletonRow />
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  )
}

export const SkeletonGroup = ({ title }: { title: string }) => (
  <div>
    <Skeleton
      variant="text"
      width={200}
      height={28}
      sx={{ fontSize: '18px', fontWeight: 600, marginBottom: '16px' }}
    />
    <SkeletonCard />
  </div>
)
